import React from 'react';
import { isIE, isSafari } from 'react-device-detect';

import { prepareBarChartData } from '../../../../helpers/itemizationDataHelper';
import { getMSBarChartOptions, getMSBarChartSeries } from '../../../../helpers/highchartHelper';
import BCLHighchart from '../../../common/Highchart/BCLHighchart';

export default class MonthlySummaryBarChart extends React.Component{

    static getDerivedStateFromProps(props, state) {
        let fuelType = props.fuelType;
        let noData = !props.itemizationData.itemizationDetails[fuelType];
        let chartData = prepareBarChartData(props.itemizationData.itemizationDetails[fuelType], props.mode, noData);
        if(chartData !== state.chartData || props.mode != state.mode ){
            return{
                highlightData : chartData.highlightData,
                lowlightData : chartData.lowLightData,
                values : chartData.values,
                mode : props.mode,
                chartHeight : chartData.chartHeight,
                noData : noData
            }
        }
        return null;
    }

    constructor(props){
        super(props);
        this.state = {
            highlightData : null,
            lowlightData : null,
            values : null,
            mode : null,
            chartHeight : null,
            noData : false
        }
    }

    render(){
        const chartOptions = getMSBarChartOptions(this.state.chartHeight);
        chartOptions.series = getMSBarChartSeries(this.state.mode, this.state.lowlightData, this.state.highlightData, this.props.appliancesList, this.props.fuelType);
        const classIfNoData = this.state.noData ? (isIE || isSafari ? "ie-no-data" : "no-data") : "";
        return(
            <div className={"ms-bar-chart " + classIfNoData}>
                <BCLHighchart options={chartOptions} ref={"chart"} immutable={false}/>
            </div>
        )
    }
}
